export default __webpack_public_path__ + "static/media/profit_pie.449390e4.svg";